// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603301656/js/" + chunkId + "." + {"44":"57bbe2c9","225":"1c463171","481":"c5c861f0","486":"a1ac01a5","770":"afad4ca1"}[chunkId] + ".0.311808057630931.chunk.js";
};